var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"1.5"},[React.createElement("path",{"className":"fill-none stroke-foreground","d":"M12,2C6.9,2,2.8,4,2.8,6.5c0,0.7,0.3,1.3,0.8,1.9l6.2,6.4v6.1c0,0.6,1,1.1,2.2,1.1s2.2-0.5,2.2-1.1v-6.1\n\t\t\tl6.2-6.4c0.5-0.6,0.8-1.2,0.8-1.9C21.2,4,17.1,2,12,2z","key":0}),React.createElement("ellipse",{"className":"fill-background--medium","cx":"12","cy":"6.5","rx":"7","ry":"3.5","key":1})]));
}

Filter.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Filter;

Filter.default = Filter;
